import { Component } from "@angular/core";

@Component({
  selector: "zafe-login-dumb",
  templateUrl: "./login-dumb.component.html",
  styleUrls: ["./login-dumb.component.scss"],
})
export class LoginDumbComponent {}
